module.exports = __webpack_public_path__ + "static/moonamar-aceite-de-comino-negro-en-capsulas-halal-880e4e4aa8fba8757830c89b63cd64a2.png";